/**
 * Scrolls the given element into view inside its scrollable container.
 * @param selectorOrElement The element or selector to scroll to (string or HTMLElement)
 * @param durationMs The duration of the scroll animation in milliseconds (default: 1000ms)
 */
export function scrollElementIntoView(selectorOrElement: string | HTMLElement, durationMs = 1000): void {
  const element =
    typeof selectorOrElement === 'string' ? document.querySelector<HTMLElement>(selectorOrElement) : selectorOrElement;
  if (!element) return;

  const container = getScrollableParent(element.parentElement);
  if (!container) return;

  const start = container.scrollTop;
  const target = element.offsetTop - container.offsetTop;
  const easeInOut = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

  let startTime: number | null = null;

  const animate = (time: number) => {
    if (startTime === null) startTime = time;
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / durationMs, 1);
    container.scrollTop = start + (target - start) * easeInOut(progress);
    if (progress < 1) requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
}

function getScrollableParent(node: HTMLElement | null): HTMLElement | null {
  while (node) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}
